// Справочник типов примеров для конструктора заданий.
// code — то, что уходит на бэк (бэк по нему генерирует случайные примеры).
// Менять code после запуска нельзя — иначе старые задания на бэке «потеряют» свои типы.

export const MIN_COUNT = 1;
export const MAX_COUNT = 10;

export const EXERCISE_GROUPS = [
    {
        id: 'addition',
        title: 'Сложение',
        types: [
            { number: 1, code: 'ADD_1_1',       label: 'Однозначные числа',                                example: '3 + 5 = 8' },
            { number: 2, code: 'ADD_2_2_RES_2', label: 'Двузначные числа, результат двузначный',           example: '23 + 41 = 64' },
            { number: 3, code: 'ADD_2_2_RES_3', label: 'Двузначные числа, результат трёхзначный',          example: '67 + 58 = 125' },
            { number: 4, code: 'ADD_3_2_RES_3_EASY', label: 'Трёхзначное и двузначное, результат трёхзначный в этой же сотне',  example: '345 + 27 = 372' },
            { number: 5, code: 'ADD_3_2_RES_3_HARD', label: 'Трёхзначное и двузначное, результат трёхзначный в след. сотне',  example: '467 + 51 = 518' },            
            { number: 6, code: 'ADD_3_3_RES_3', label: 'Трёхзначные числа, результат трёхзначный',         example: '214 + 352 = 566' },
            { number: 7, code: 'ADD_3_3_RES_4', label: 'Трёхзначные числа, результат четырёхзначный',      example: '678 + 545 = 1223' },
        ],
    },
    {
        id: 'subtraction',
        title: 'Вычитание',
        types: [
            { number: 8,  code: 'SUB_1_1',       label: 'Однозначные числа',                               example: '8 − 3 = 5' },
            { number: 9,  code: 'SUB_2_1_RES_2',       label: 'Двузначное и однозначное, результат двузначный',                        example: '47 − 8 = 39' },
            { number: 10,  code: 'SUB_2_1_RES_1',  label: 'Двузначное и однозначное, результат однозначный',                        example: '17 − 9 = 8' },
            { number: 11,  code: 'SUB_2_2_RES_1', label: 'Двузначные числа, результат однозначный',         example: '52 − 47 = 5' },
            { number: 12, code: 'SUB_2_2_RES_2', label: 'Двузначные числа, результат двузначный',          example: '85 − 32 = 53' },
            { number: 13, code: 'SUB_3_3_RES_2', label: 'Трёхзначные числа, результат двузначный',         example: '532 − 487 = 45' },
            { number: 14, code: 'SUB_3_3_RES_3', label: 'Трёхзначные числа, результат трёхзначный',        example: '754 − 321 = 433' },
        ],
    },
];

export const ALL_EXERCISE_TYPES = EXERCISE_GROUPS.flatMap((g) => g.types);
